import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ClientBaseApiService } from 'src/app/core/api/client-base-api.service';
import { StorageKeys } from 'src/app/core/models/enums/storage-keys';
import { LoadingService } from 'src/app/core/services/loading.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-user-manual',
  templateUrl: './user-manual.component.html',
  styleUrls: ['./user-manual.component.scss'],
})
export class UserManualComponent implements OnInit {
  currentPage: number = 1
  zoom: number = 1
  safeUrl;
  fileUrl: string = ""
  error: boolean = false
  isFiliz: boolean = false;
  userManual: string;
  folder: string;
  constructor(private translate: TranslateService, private clientProxy: ClientBaseApiService, private storageService: StorageService, private loadingService: LoadingService) { }
  ngOnInit() {
    this.loadingService.showLoading();
    let lang = this.translate.currentLang;
    if (!lang || lang == '')
    lang = "en";
    lang = lang.toUpperCase();
    this.storageService.get(StorageKeys.FILIZ_MODE).then(res => {
      if (res.Data) {
        this.isFiliz = true;
        this.translate.get('userManualPrefix.filiz-user-manual').subscribe((translation: string) => {
          this.userManual = translation + (lang === 'TR' ? 'TR' : 'EN');
        });
        this.folder = "filiz";
      } else {
        this.isFiliz = false;
        this.translate.get('userManualPrefix.pesttrap-user-manual').subscribe((translation: string) => {
          this.userManual = translation + (lang === 'TR' ? 'TR' : 'EN');
        });
        this.folder = "pesttrap";
      }
      let userManualFilePath = environment.UserManualBaseUrl + this.folder + "/" + this.userManual + ".pdf";
      this.clientProxy.checkFileExist(userManualFilePath).subscribe(response => {
        if (typeof response === 'string') {
          this.fileUrl = userManualFilePath;
          setTimeout(() => {
            this.loadingService.hideLoading();
          }, 100);
        } else {
          userManualFilePath = environment.UserManualBaseUrl + "PestTrap_1.5-User_Manual-EN.pdf"
          this.clientProxy.checkFileExist(userManualFilePath).subscribe(response2 => {
            if (typeof response2 === 'string') {
              this.fileUrl = userManualFilePath;
            } else {
              this.error = true;
            }
            setTimeout(() => {
              this.loadingService.hideLoading();
            }, 100);
          })
        }
      })
    })
  }

  zoomOut() {
    if (this.zoom > 1)
      this.zoom = this.zoom - 0.1
  }
  zoomIn() {
    this.zoom = this.zoom + 0.1
  }
  pageChanged(ev) {
    this.currentPage = ev
  }
  playAudio(itemId) {
    let audioElemenet: any = document.getElementById(itemId)
    audioElemenet.play()
  }
}

